// extracted by mini-css-extract-plugin
var _1 = "PageHeader-modulelink__ZL37k";
var _2 = "PageHeader-modulenav__SeAaC";
var _3 = "PageHeader-modulewrapper__ZRRDM";
export { _1 as "link", _2 as "nav", _3 as "wrapper" }
